import React, { useState, useEffect } from 'react';
import DataTable from '../components/DataTable';
import { documentsAPI } from '../lib/api';

const Documents = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchDocuments = async () => {
    setLoading(true);
    try {
      const response = await documentsAPI.getAll();
      setDocuments(response.data);
    } catch (error) {
      console.error('Error fetching documents:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, []);

  const columns = [
    { key: 'name', label: 'Document Name' },
    { key: 'type', label: 'Type' },
    { key: 'reference_type', label: 'Reference' },
    { key: 'size', label: 'Size', render: (val) => val ? `${Math.round(val / 1024)} KB` : '-' },
  ];

  const formFields = [
    { name: 'name', label: 'Document Name', required: true, placeholder: 'Enter document name' },
    {
      name: 'type',
      label: 'Document Type',
      type: 'select',
      required: true,
      options: [
        { value: 'contract', label: 'Contract' },
        { value: 'invoice', label: 'Invoice' },
        { value: 'report', label: 'Report' },
        { value: 'proposal', label: 'Proposal' },
        { value: 'other', label: 'Other' },
      ],
    },
    { name: 'reference_type', label: 'Reference Type', placeholder: 'e.g., client, project' },
    { name: 'reference_id', label: 'Reference ID', placeholder: 'ID of related item' },
    { name: 'url', label: 'Document URL', placeholder: 'https://...' },
  ];

  const handleAdd = async (data) => {
    await documentsAPI.create(data);
    fetchDocuments();
  };

  const handleEdit = async (id, data) => {
    await documentsAPI.update(id, data);
    fetchDocuments();
  };

  const handleDelete = async (id) => {
    await documentsAPI.delete(id);
    fetchDocuments();
  };

  return (
    <DataTable
      title="Documents"
      description="Manage your documents and files"
      data={documents}
      columns={columns}
      formFields={formFields}
      onAdd={handleAdd}
      onEdit={handleEdit}
      onDelete={handleDelete}
      loading={loading}
    />
  );
};

export default Documents;
